export class MessageService { 

    public static parseHiddenDatasInBotMessageKey(key: string): any {
        const result:any = {};
        const infos= key.match(/##([\s\S]*?)##/);
        let paramArray: any = [];

        if (infos && infos[0]) {
            paramArray = infos[0].replace(/##/g,"").split("|");
        } 
        
        for (let i :number = 0; i < paramArray.length; i++) {
            const param = paramArray[i].split("=")
            if ( param[1]) {
                result[param[0]] = param[1];
            } else {
                result[param[0]] = param[0];
            }
        }
        
        return result;
    }   
}